"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isMedia360Video = isMedia360Video;
exports.sortMediaWith360First = sortMediaWith360First;
const TDR_1 = __importDefault(require("../types/TDR"));
function isMedia360Video(item) {
    var _a;
    if (item.type !== TDR_1.default.MediaType.VIDEO) {
        return false;
    }
    const withLegacy = item;
    if ((_a = withLegacy.tags) === null || _a === void 0 ? void 0 : _a.includes(TDR_1.default.TableMediaTag.VIEW_360)) {
        return true;
    }
    return withLegacy.tag === TDR_1.default.TableMediaTag.VIEW_360;
}
function sortMediaWith360First(media) {
    if (!media.length) {
        return media;
    }
    const threeSixty = [];
    const rest = [];
    for (const m of media) {
        if (isMedia360Video(m)) {
            threeSixty.push(m);
        }
        else {
            rest.push(m);
        }
    }
    return [...threeSixty, ...rest];
}
//# sourceMappingURL=sortMediaWith360First.js.map